import search from './search.svg';
import kf from './kf.svg';
import answer from './answer.svg';
import chatsLeft from './chats-left.svg';
import chatsRight from './chats-right.svg';
import ipad from './ipad.svg';

export default {
  search,
  kf,
  answer,
  chatsLeft,
  chatsRight,
  ipad,
};



// WEBPACK FOOTER //
// ./src/img/howItWorks/index.js